import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(),
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(4)
  }
}));

export const AddBtnCnt = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2)
}));

export const AddBtn = styled(IconButton)(({ theme }) => ({
  marginLeft: theme.spacing(1.625)
}));

export const ButtonCnt = styled('div', {
  shouldForwardProp: prop => prop !== 'hasBorderTop'
})(({ theme, hasBorderTop }) => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: '#EEE',
  zIndex: theme.zIndex.appBar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(),
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  ...(hasBorderTop && {
    borderTop: `1px solid ${theme.palette.grey[400]}`,
    boxShadow: 'rgba(0, 0, 0, 0.45) 0px -17px 20px -22px'
  })
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));
